"use client";
import React, { ReactNode } from "react";
import { MinusCircle } from "lucide-react";
import { ShortLGS } from "modules/common/model/models";
import { ICON_SIZE } from "modules/common/components/navigation/Menu";
import { StoreList } from "modules/lgs/components/StoreList";

interface YourStoresListProps {
  userStores: ShortLGS[];
  handleChange: (storeId: number) => void;
  shopCheckedState: Record<number | string, boolean>;
  compact?: boolean;
  saveIndicator?: ReactNode;
}

export function YourStoresList({
  userStores,
  handleChange,
  shopCheckedState,
  compact = false,
  saveIndicator,
}: YourStoresListProps) {
  // userStores already contains the selected stores, no need to filter by shopCheckedState
  const selectedStores = userStores;
  const hasStores = selectedStores.length > 0;
  const storeCount = `${selectedStores.length}/5`;

  // Format stores for the StoreList component
  const formattedStores = selectedStores.map((store) => ({
    id: store.wotcId,
    name: store.name,
    isTradingHub: store.isTradingHub,
  }));
  return (
    <StoreList
      title="Your trading locations"
      titleAdornment={saveIndicator}
      count={storeCount}
      stores={formattedStores}
      emptyMessage="No trading locations selected yet"
      onStoreClick={handleChange}
      renderIcon={() =>
        compact ? (
          <MinusCircle
            size={ICON_SIZE}
            className="text-error shrink-0"
            aria-hidden="true"
          />
        ) : (
          <span className="bg-error/10 text-error grid size-8 shrink-0 place-items-center rounded-full">
            <MinusCircle size={ICON_SIZE} aria-hidden="true" />
          </span>
        )
      }
      statusMessage={
        !hasStores ? "Please select a trading location" : undefined
      }
      iconPosition="right"
      compact={compact}
    />
  );
}

export default YourStoresList;
